import type { OceanAgentRole } from "@vida/currents-core";

export type EditorSection = "profile" | "assignments" | "access" | "team" | "budget";

type NavItem = {
  id: EditorSection;
  label: string;
  show?: boolean;
};

type Props = {
  section: EditorSection;
  role: OceanAgentRole;
  onSectionChange: (section: EditorSection) => void;
};

export function AgentEditorSidebar({ section, role, onSectionChange }: Props) {
  const items: NavItem[] = [
    { id: "profile", label: "Profilo" },
    { id: "assignments", label: "Assegnazioni" },
    { id: "access", label: "Accesso" },
    { id: "team", label: "Team", show: role === "ORCHESTRATOR" },
    { id: "budget", label: "Budget" },
  ];

  return (
    <nav className="editor-sidebar" aria-label="Sezioni agente">
      <ul>
        {items
          .filter((item) => item.show !== false)
          .map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={section === item.id ? "active" : ""}
                onClick={() => onSectionChange(item.id)}
                aria-current={section === item.id ? "page" : undefined}
              >
                {item.label}
              </button>
            </li>
          ))}
      </ul>
    </nav>
  );
}
